// extracted by mini-css-extract-plugin
export default {"modalOverlay":"modal_modalOverlay__ynORc","modalCard":"modal_modalCard__+xibv","modalHeading":"modal_modalHeading__yNDva"};